require('jquery-validation');

var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var ValidationHelpers = require('./validate-helpers');

var FORMS      = '.js-formValidateSubmitMailChimp';

module.exports = function() {

    $(FORMS).each(function(){

        $FORM = $(this);

        $FORM.validate({

            // On Validation, submit the form
            submitHandler: function(form) {

                var $validatedForm = $(form);
                var ajaxAction = $validatedForm.attr('action') + '-json?c=?';

                var success_message = $validatedForm.find('[data-helper-name=success_message]').val();
                var generic_error_message = $validatedForm.find('[data-helper-name=generic_error_message]').val();

                ValidationHelpers.setLoading( $validatedForm, true);

                var formXHR = $.ajax({
                    url: ajaxAction,
                    type: 'GET',
                    data: $validatedForm.serialize(),
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8'
                });

                formXHR.done(function(resp) {
                    if (typeof resp.result === 'undefined' || resp.result != 'success' ) {
                        ValidationHelpers.showMessage( $validatedForm, generic_error_message || resp.msg, false);
                    }
                    else {
                        ValidationHelpers.showMessage( $validatedForm, success_message || resp.msg, true);
                        $validatedForm.find('input[name=email]').val('');
                    }
                });

                /*
                 * Ajax request failed, either in transport or the application threw a 500 error.
                 */
                formXHR.fail(function(jqXHR, textStatus, errorThrown) {
                    ValidationHelpers.showMessage( $validatedForm, generic_error_message || resp.msg, false);
                });


                formXHR.always(function(){
                    ValidationHelpers.setLoading( $validatedForm, false);
                });

            }

        });

        /*
         * This helper method prepares messages for the validator.
         * It MUST be loaded after the validator is loaded.
         */
        ValidationHelpers.loadFormMessages($FORM);

    });

};
